import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import './index.css'

function getRandomInt(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
}

export default function EntryPlaceholder({
  hasLoadingPulseAnimation = false,
  renderPlaceholderIcon = () => {},
  minWidth = 40,
  maxWidth = 80,
}) {
  return (
    <div
      className={classnames('flexbox flexbox-align-center margin-top-normal', {
        'pulse-animation': hasLoadingPulseAnimation,
      })}
    >
      {renderPlaceholderIcon()}

      <div
        style={{
          height: '24px',
          width: `${getRandomInt(minWidth, maxWidth)}%`,
        }}
        className="radius-normal background-shade-50"
      />
    </div>
  )
}

EntryPlaceholder.propTypes = {
  renderPlaceholderIcon: PropTypes.func,
  hasLoadingPulseAnimation: PropTypes.bool,
  minWidth: PropTypes.number,
  maxWidth: PropTypes.number,
}
